import { render, staticRenderFns } from "./PackageVariant.vue?vue&type=template&id=9a5ab29c&"
import script from "./PackageVariant.vue?vue&type=script&lang=js&"
export * from "./PackageVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports